(function () {

    // Enable the order confirmation email link to load the order details page within the iframe.
    if (window.location.href.indexOf('orderNumber=') != -1 && window.location.href.indexOf('crmUserId=') != -1) {
        var orderId = window.location.href.split('orderNumber=')[1];
        var crmUserId = window.location.href.split('crmUserId=')[1];
        orderId = orderId.indexOf('&') != -1 ? orderId.split('&')[0] : orderId;
        crmUserId = crmUserId.indexOf('&') != -1 ? crmUserId.split('&')[0] : crmUserId;
        window.iframeUrl != null ? window.iframeUrl += "&orderNumber=" + orderId + "&crmUserId=" + crmUserId : null;
        document.querySelector('#js-embeddable').src = window.iframeUrl;
    }
    else if (window.location.href.indexOf('track-your-order') != -1 && window.location.href.indexOf('orderNumber=') == -1 && window.location.href.indexOf('crmUserId=') == -1) {
        // Load the track my order page by default
        document.querySelector('#js-embeddable').src = window.iframeUrl;
    }
    else if (window["iframeUrl"] != null && window.iframeUrl.indexOf('our-stores/store-results') != -1) {
        var properties = "";
        if (window.location.href.indexOf('latLng') != -1) {
            properties = window.location.href.substring(window.location.href.indexOf('latLng'))
        }

        document.querySelector('#js-embeddable').src = window.iframeUrl + "&referrerPath=" + window.location.pathname + "&" + properties
    }





})();

window.neptune.iframe.library = {
    // For each iframe on page create a configuration

    create: function () {
        document.querySelectorAll(".iframe-embeddable").forEach(element => {
            const id = "id_" + Math.random().toString().split(".")[1];
            element.setAttribute("id", id);
            var configScript = document.createElement("script");
            configScript.id = "iFrameResizer-config-" + id;
            configScript.innerHTML = "iFrameResize([{log:true, autoResize:false}], '#" + id + "')";
            element.parentNode.appendChild(configScript);
        });
    }

}